<!-- chamba-ai#433: the panel is always mounted on desktop and toggles
     between expanded (icon + label) and an icon-only rail from the navbar
     hamburger; on mobile HomeComponent renders it as an off-canvas drawer.
     Nav items are real links with routerLinkActive so the current page is
     highlighted (and announced via aria-current="page"). Tooltips only
     fire in the rail, where the label itself is hidden. -->
<nav class="nav-bar" [attr.aria-label]="t.NAV_ARIA_LABEL">
  <div class="nav-bar-main">
    <ng-content select="[nav-icons]">
      <span class="nav-section-title">{{ t.SECTION_CREATE }}</span>

      <button
        type="button"
        class="nav-icon-btn nav-icon-btn-primary"
        [class.is-active]="isApplyRoute"
        [appLockedUnless]="'agent.applyJob'"
        (click)="openWizard()"
        [attr.aria-label]="t.ADD_NEW_APPLICATION"
        pTooltip="{{ t.ADD_NEW_APPLICATION }}"
        [tooltipDisabled]="!collapsed"
        pTooltipShowDelay="300"
        tooltipPosition="right"
      >
        <i class="bi bi-plus-lg" aria-hidden="true"></i>
        <span class="nav-icon-label">{{ t.ADD_NEW_APPLICATION }}</span>
      </button>

      <a
        [appLockedUnless]="'agent.batchTailor'"
        routerLink="/home/batch-tailor"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
        class="nav-icon-btn"
        (click)="navigated.emit()"
        [attr.aria-label]="t.OPEN_BATCH_TAILOR"
        pTooltip="{{ t.OPEN_BATCH_TAILOR }}"
        [tooltipDisabled]="!collapsed"
        pTooltipShowDelay="300"
        tooltipPosition="right"
      >
        <i class="bi bi-layers" aria-hidden="true"></i>
        <span class="nav-icon-label">{{ t.OPEN_BATCH_TAILOR }}</span>
      </a>

      <span class="nav-section-title">{{ t.SECTION_WORKSPACE }}</span>

      <a
        routerLink="/home/dashboard"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
        class="nav-icon-btn"
        (click)="navigated.emit()"
        [attr.aria-label]="t.OPEN_DASHBOARD"
        pTooltip="{{ t.OPEN_DASHBOARD }}"
        [tooltipDisabled]="!collapsed"
        pTooltipShowDelay="300"
        tooltipPosition="right"
      >
        <i class="bi bi-grid-1x2" aria-hidden="true"></i>
        <span class="nav-icon-label">{{ t.OPEN_DASHBOARD }}</span>
      </a>

      <!-- /home is the applications list itself, so it must match exactly
           or it would light up on every /home/** page. -->
      <a
        routerLink="/home"
        routerLinkActive="is-active"
        [routerLinkActiveOptions]="exactMatch"
        ariaCurrentWhenActive="page"
        class="nav-icon-btn"
        (click)="navigated.emit()"
        [attr.aria-label]="t.OPEN_APPLICATIONS"
        pTooltip="{{ t.OPEN_APPLICATIONS }}"
        [tooltipDisabled]="!collapsed"
        pTooltipShowDelay="300"
        tooltipPosition="right"
      >
        <i class="bi bi-briefcase" aria-hidden="true"></i>
        <span class="nav-icon-label">{{ t.OPEN_APPLICATIONS }}</span>
      </a>

      <a
        routerLink="/home/recent-jobs"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
        class="nav-icon-btn"
        (click)="navigated.emit()"
        [attr.aria-label]="t.OPEN_RECENT_JOBS"
        pTooltip="{{ t.OPEN_RECENT_JOBS }}"
        [tooltipDisabled]="!collapsed"
        pTooltipShowDelay="300"
        tooltipPosition="right"
      >
        <i class="bi bi-fire" aria-hidden="true"></i>
        <span class="nav-icon-label">{{ t.OPEN_RECENT_JOBS }}</span>
      </a>

      <!-- "My CVs"/Profile CVs nav icon removed (chamba-ai#268) - Root CV is
           the only base now, so that section no longer has a place in
           day-to-day navigation. Still reachable directly at
           /home/user-cvs for anyone who needs it. -->
      <a
        routerLink="/home/root-cv"
        routerLinkActive="is-active"
        ariaCurrentWhenActive="page"
        id="nav-root-cv-btn"
        class="nav-icon-btn"
        [class.tutorial-highlight]="highlightRootCv"
        (click)="navigated.emit()"
        [attr.aria-label]="t.OPEN_ROOT_CV"
        pTooltip="{{ t.OPEN_ROOT_CV }}"
        [tooltipDisabled]="!collapsed"
        pTooltipShowDelay="300"
        tooltipPosition="right"
      >
        <i class="bi bi-collection" aria-hidden="true"></i>
        <span class="nav-icon-label">{{ t.OPEN_ROOT_CV }}</span>
      </a>
    </ng-content>

    <span class="nav-section-title">{{ t.SECTION_TOOLS }}</span>

    <a
      routerLink="/home/ats-scan"
      routerLinkActive="is-active"
      ariaCurrentWhenActive="page"
      class="nav-icon-btn"
      (click)="navigated.emit()"
      [attr.aria-label]="t.OPEN_ATS_SCAN"
      pTooltip="{{ t.OPEN_ATS_SCAN }}"
      [tooltipDisabled]="!collapsed"
      pTooltipShowDelay="300"
      tooltipPosition="right"
    >
      <i class="bi bi-clipboard-check" aria-hidden="true"></i>
      <span class="nav-icon-label">{{ t.OPEN_ATS_SCAN }}</span>
    </a>
  </div>

  <div class="nav-bar-bottom">
    <ng-content select="[nav-bottom]">
      <button
        type="button"
        (click)="toggleTheme()"
        class="theme-toggle-switch"
        role="switch"
        [attr.aria-checked]="themeService.isDark()"
        [attr.aria-label]="t.THEME_SELECT"
        pTooltip="{{ t.THEME_SELECT }}"
        pTooltipShowDelay="500"
        tooltipPosition="top"
      >
        <i class="bi bi-brightness-high-fill theme-toggle-icon" aria-hidden="true"></i>
        <span class="theme-toggle-track">
          <span class="theme-toggle-thumb" [class.is-dark]="themeService.isDark()"></span>
        </span>
        <i class="bi bi-moon-stars-fill theme-toggle-icon" aria-hidden="true"></i>
      </button>
    </ng-content>
  </div>
</nav>
